// extracted by mini-css-extract-plugin
var _1 = "LayoutHeader-moduleLayoutHeader__AutB8 Header-moduleHeader__xYejq";
var _2 = "LayoutHeader-modulecollapsed__cuPcp";
var _3 = "LayoutHeader-moduleexpanded__vV1rX";
var _4 = "LayoutHeader-moduleheaderSeparator__H2JGP HeaderSeparator-moduleHeaderSeparator__yvydf";
var _5 = "LayoutHeader-moduleheaderSeparatorPlaceholder__gb6lZ";
var _6 = "LayoutHeader-modulehidden__Kyong";
var _7 = "LayoutHeader-modulemenuToggle__zWeZw LayoutHeaderMenuToggle-moduleLayoutHeaderMenuToggle__plT5D";
var _8 = "LayoutHeader-modulesearch__ixrsY Search-moduleSearch__miXMq";
var _9 = "LayoutHeader-modulesearchFull__kTP76";
var _a = "LayoutHeader-modulesearchOpen__pYJSq";
var _b = "LayoutHeader-moduleuserMenu__y63DK UserMenu-moduleUserMenu__iP37A";
export { _1 as "LayoutHeader", _2 as "collapsed", _3 as "expanded", _4 as "headerSeparator", _5 as "headerSeparatorPlaceholder", _6 as "hidden", _7 as "menuToggle", _8 as "search", _9 as "searchFull", _a as "searchOpen", _b as "userMenu" }
